import React, { Component } from 'react';
import moment from 'moment';
import Swipe from 'react-easy-swipe';
import LocalDataManager from '../managers/LocalDataManager';
import PermissionManager from '../managers/PermissionManager';
import BroadcastService from '../services/BroadcastService';
import AccountService from '../services/AccountService';
import GoalsContestsService from '../services/GoalsContestsService';
import ContestsService from '../services/ContestsService';
import BlastDataManager from '../managers/BlastDataManager.js';
import MetricsViewCentral from '../components/Metrics/MetricsViewCentral.js';
import MetricsViewRight from '../components/Metrics/MetricsViewRight.js';
import MetricsTopBar from './Metrics/MetricsTopBar';
import MetricsBottomBar from './Metrics/MetricsBottomBar';
import LongitudinalDataDisplay from './Utility/LongitudinalDataDisplay';

export default class MetricsPage extends Component {

    constructor(props) {
        super(props);

        window.zzActiveObject = this;

        this.dbm = new LocalDataManager();
        this.accountService = new AccountService();
        this.broadcastService = new BroadcastService();
        this.blastDataManager = new BlastDataManager();
        this.permissionManager = new PermissionManager();
        this.defaultProps = {}
        this.errmsg = "Something went wrong while loading the data.";
        this.state = {
            isGroupsMode: window.localStorage.isGroupsMode != undefined ? window.localStorage.isGroupsMode === "true" : false,
            lastBlastReload: new Date("1/1/1970"),
            blastFilter: {
                companyId: 0,
                date: moment().format("MM/DD/YYYY"),
                storeId: undefined,
                districtId: undefined,
                range: "CUR", //WTD,MTD,QTD,YTD
                dataMode: "D", //N (Number), P (%), D (Delta)
                sortBy: window.localStorage.metricSortBy != undefined ? window.localStorage.metricSortBy : "cY", //cY, lY, NAME, DEFAULT (defaultSortOrder)
                sortByDir: window.localStorage.metricSortByDir != undefined ? window.localStorage.metricSortByDir : "DESC", //ASC
                metricNameEmployee: undefined,
                metricNameLocation: undefined,
                nameEmployee: undefined,
                nameLocation: undefined,
                nameAllEmployee: undefined
            },
            blastData: undefined,
            peekBlastData: null,
            screenContext: {
                activeList: 'locationMetricList',
                groupKey: 'Total Sales',
                hasCharts: true,
                headerText: 'Locations',
                isMetric: false,
                screen: 'locs',
                showBack: false
            },
            peekScreenContext: null,
            canCreateMetricGroups: false,
            userId: undefined,
            userType: undefined,
            allStoreIDs: undefined,
            isScrollTop: true,
            selectedItems: [],
            isSearchMode: false,
            searchText: '',
            searchTop: 0,
            accountInfo: null,
            activeGoals: [],
            activeContests: [],
            isScrollDirectionDown: false,
            drillingIn: 'still',
            rightOptions: {
                chart: {
                    active: true,
                    hold: false,
                    solo: false,
                    icon: 'insert_chart_outlined'
                },
                goals: {
                    active: true,
                    hold: false,
                    solo: false,
                    icon: 'goals'
                },
                contests: {
                    active: true,
                    hold: false,
                    solo: false,
                    icon: 'contests'
                },
                clipBoard: {
                    active: true,
                    hold: false,
                    solo: false,
                    icon: 'table_chart'
                },
                peek: {
                    active: false,
                    hold: false,
                    solo: false,
                    icon: 'visibility'
                }
            }
        }

        this.settings = this.dbm.getSettingsInfo();

        this.userInfo = null;
        this.locationMap = null;
        this.userMap = null;
        this.storeMap = null;
        this.meKey = null;
        this.primaryLocation = null;

        this.hasDistricts = false;

        this.defaultGroupKey = '';

        this.swipeMode = 0;
        this.swipeX = 0;
        this.swipeY = 0;
        this.scrollTop = 0;
        this.curView = null;

        this.caGoalSwitch = false;
        this.lGoalSwitch = false;
        this.uGoalSwitch = false;
        this.clientAccountGoals = null;
        this.locationGoals = null;
        this.userGoals = null;

        this.goalTimeout = null;
        this.goalTimeoutCounter = 0;
        this.blastTimeout = null;
        this.blastTimeoutCounter = 0;

        this.allContests = [];

        this.gcService = new GoalsContestsService();
        this.contestService = new ContestsService();

        this.backStack = [];
        this.isScreenChanging = false;

        this.employeeMetricList = [];
        this.locationMetricList = [];
        this.locationList = [];
        this.employeeList = [];
        this.allEmployeeList = [];
        this.districtMetricList = [];
        this.districtList = [];
        this.districtLocationMetricList = [];
        this.districtLocationList = [];

        this.employeePhoneList = [];
        this.locationPhoneList = [];

        this.changingDate = false;
        this.changingGoals = true;

        this.isLocked = this.isLocked.bind(this);

        this.blastSubCallbackAction = this.blastSubCallbackAction.bind(this);
        this.blastSubCallback = this.blastSubCallback.bind(this);
        this.blastInit = this.blastInit.bind(this);
        this.loadBlastData = this.loadBlastData.bind(this);
        this.loadBlastDataAgain = this.loadBlastDataAgain.bind(this);
        this.loadBlastDataAgainSimple = this.loadBlastDataAgainSimple.bind(this);

        this.promptForLongData = this.promptForLongData.bind(this);

        this.setCompareMode = this.setCompareMode.bind(this);
        this.loadGoalsContests = this.loadGoalsContests.bind(this);
        this.loadGoals = this.loadGoals.bind(this);
        this.updateActiveGoals = this.updateActiveGoals.bind(this);
        this.getActiveGoals = this.getActiveGoals.bind(this);
        this.overwriteGoalData = this.overwriteGoalData.bind(this);

        // new contest methods
        this.loadMyContests = this.loadMyContests.bind(this);
        this.updateActiveContests = this.updateActiveContests.bind(this);
        this.getActiveContests = this.getActiveContests.bind(this);

        this.changeDate = this.changeDate.bind(this);
        this.changeSort = this.changeSort.bind(this);
        this.rotateSort = this.rotateSort.bind(this);
        this.rotateSortDir = this.rotateSortDir.bind(this);
        this.rotateFilter = this.rotateFilter.bind(this);
        this.rotateDataMode = this.rotateDataMode.bind(this);
        this.updateBlastFilter = this.updateBlastFilter.bind(this);

        this.handleScrollTop = this.handleScrollTop.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.handleScrollDirection = this.handleScrollDirection.bind(this);

        this.setScreenContext = this.setScreenContext.bind(this);

        this.toggleSelectedItem = this.toggleSelectedItem.bind(this);
        this.clearSelectedItems = this.clearSelectedItems.bind(this);
        this.selectAllItems = this.selectAllItems.bind(this);
        this.toggleSearch = this.toggleSearch.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleSearchTop = this.handleSearchTop.bind(this);
        this.handleChangeScreen = this.handleChangeScreen.bind(this);
        this.handleChangeScreenForce = this.handleChangeScreenForce.bind(this);
        this.handleChangeScreenLong = this.handleChangeScreenLong.bind(this);
        this.handleChangeScreenPrevious = this.handleChangeScreenPrevious.bind(this);
        this.changeScreenLocked = this.changeScreenLocked.bind(this);
        this.goToMe = this.goToMe.bind(this);
        this.toggleGroupsMode = this.toggleGroupsMode.bind(this);
        this.handleChangeTopSelector = this.handleChangeTopSelector.bind(this);
        this.handleChangePeekTopSelector = this.handleChangePeekTopSelector.bind(this);
        this.handleForceBlast = this.handleForceBlast.bind(this);

        this.onSwipeStart = this.onSwipeStart.bind(this);
        this.onSwipeMove = this.onSwipeMove.bind(this);
        this.onSwipeEnd = this.onSwipeEnd.bind(this);
        this.onSwipeLeft = this.onSwipeLeft.bind(this);
        this.onSwipeRight = this.onSwipeRight.bind(this);
        this.animateSwipe = this.animateSwipe.bind(this);

        this.textPeople = this.textPeople.bind(this);
        this.callPeople = this.callPeople.bind(this);

        this.canSelectPeriod = this.canSelectPeriod.bind(this);

        this.setRightOption = this.setRightOption.bind(this);
        this.setRightOptionSolo = this.setRightOptionSolo.bind(this);
        this.loadPeekData = this.loadPeekData.bind(this);
        this.canPeek = this.canPeek.bind(this);

        let self = this;
        self.props.superInit(self.blastInit, undefined, () => { window.zzIsPaused = false; self.props.loadingOn(); self.loadBlastDataAgain(); }, undefined);
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.state.isGroupsMode != prevState.isGroupsMode) {
            this.props.loadingOn();
            let self = this;

            let reloadFunction = () => {
                self.dbm.clearBlastData(() => {
                    self.loadBlastDataAgain(() => {

                        if (self.hasDistricts) {
                            self.handleChangeScreenForce("dists");
                        } else {
                            if (!self.state.isGroupsMode && ["dists", "dist", "distLocs", "distLoc"].includes(self.state.screenContext.screen)) {
                                self.handleChangeScreenForce("locs");

                            } else if (self.state.isGroupsMode) {
                                self.handleChangeScreenForce("dists");
                            }
                        }
                    });
                })
            }

            if (this.state.isGroupsMode) {
                self.props.blastService.unsubscribeAll(() => {
                    reloadFunction();
                }, () => {
                    reloadFunction();
                });
            } else {
                reloadFunction();
            }
        }
    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    isLocked() {
        return (this.state.userType === 5 && this.primaryLocation != undefined && this.primaryLocation != null && this.primaryLocation.isEmployeeLocked);
    }

    async blastSubCallbackAction(subLastUpdate) {

        let self = this;

        self.loadBlastData(self.state.blastFilter, self.state.screenContext.screen, (subData) => {

            self.getPhoneNumbers(self.state.blastFilter);
            let subBlastData = subData;

            self.setState({ blastData: subBlastData, lastBlastReload: subLastUpdate }, () => {

                self.updateActiveGoals();
                //self.updateActiveContests();

                if (!self.props.isPhone) {
                    self.loadPeekData();
                }
            });
        });
    }

    blastSubCallback(subLastUpdate) {
        let self = this;

        if (self.blastTimeout != null) {
            clearTimeout(self.blastTimeout);
        }

        if (self.blastTimeoutCounter++ >= (self.state.allStoreIDs.length > 1 ? self.state.allStoreIDs.length : 25)) {
            self.blastTimeoutCounter = 0;
            self.blastSubCallbackAction(subLastUpdate);
        } else {
            self.blastTimeout = setTimeout(() => {
                self.blastTimeoutCounter = 0;
                self.blastSubCallbackAction(subLastUpdate);
            }, 1000);
        }
    }

    blastInit() {

        let self = this;
        self.dbm.getAccountInfo().then((userInfo) => {
            if (userInfo.clientAccountList.length > 0) {
                
                if(userInfo.isDashboardOnly)
                {
                    self.props.changePage('login', false);
                    return;
                }
                self.userInfo = userInfo;
                self.locationMap = userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {
                    let key = e.locationID;
                    if (!r[key]) {
                        r[key] = e.name;
                    }

                    return r;
                }, {});

                self.storeMap = userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {

                    let key = e.clusterID;
                    if (!r[key]) {
                        r[key] = e.name;
                    }

                    return r;
                }, {});

                let companyId = userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].companyID;
                let allStoreIDs = userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].storeIDs;
                let userId = userInfo.userId;
                let filter = {
                    companyId: userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].companyID,
                    date: moment().format("MM/DD/YYYY"),
                    storeId: undefined,
                    districtId: undefined,
                    range: "CUR", //WTD,MTD,QTD,YTD
                    dataMode: "D", //N (Number), P (%), D (Delta)
                    sortBy: window.localStorage.metricSortBy != undefined ? window.localStorage.metricSortBy : "cY", //cY, lY, NAME, DEFAULT (defaultSortOrder)
                    sortByDir: window.localStorage.metricSortByDir != undefined ? window.localStorage.metricSortByDir : "DESC", //ASC
                    activeList: "locationMetricList",
                    metricNameEmployee: undefined,
                    metricNameLocation: undefined,
                    metricNameDistrict: undefined,
                    nameEmployee: undefined,
                    nameLocation: undefined,
                    nameAllEmployee: undefined,
                    nameDistrict: undefined
                }

                let hasDefaultScreenContext = false;

                if (userInfo.clientAccountList.length > 0) {
                    hasDefaultScreenContext = true;
                    let districtIdList = Object.values(userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {
                        let key = e.districtId;
                        if (!r[key]) {
                            r[key] = e.districtId;
                        }
                        return r;
                    }, {}));

                    if (districtIdList.length > 1 || self.state.isGroupsMode) {
                        if (districtIdList.length > 1) {
                            self.hasDistricts = true;
                        }
                        self.state.screenContext = {
                            activeList: 'districtMetricList',
                            groupKey: '',
                            hasCharts: !self.state.isGroupsMode,
                            headerText: self.state.isGroupsMode ? 'Groups' : 'Districts',
                            isMetric: false,
                            screen: 'dists',
                            showBack: false
                        }

                        filter.activeList = 'employeeList';
                    }
                }

                if (userInfo.userType === 5) {
                    hasDefaultScreenContext = true;
                    self.state.screenContext = {
                        activeList: 'allEmployeeList',
                        groupKey: '',
                        hasCharts: false,
                        headerText: 'Employee',
                        isMetric: true,
                        screen: 'allemp',
                        showBack: true
                    }

                    filter.activeList = 'employeeList';

                    for (var i = 0; i < userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.length; i++) {
                        if (userInfo.primaryLocationCluster === userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations[i].clusterID) {
                            self.primaryLocation = userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations[i];
                            break;
                        }
                    }

                    if (self.primaryLocation != undefined && self.primaryLocation != null && self.primaryLocation.isEmployeeLocked) {

                        self.state.screenContext.showBack = false;

                        if (userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.length <= 1) {

                        } else {

                        }
                    } else {
                        self.backStack.push({ screen: 'locs', groupKey: 'Total Sales', storeId: undefined });
                    }
                }

                if (!hasDefaultScreenContext) {
                    self.state.screenContext = {
                        activeList: 'locationMetricList',
                        groupKey: '',
                        hasCharts: true,
                        headerText: 'Locations',
                        isMetric: false,
                        screen: 'locs',
                        showBack: false
                    }
                }

                let blastDataCallback = (lastUpdate) => {
                    self.loadBlastData(filter, self.state.screenContext.screen, (data) => {

                        self.getPhoneNumbers(filter);
                        self.userMap = self.blastDataManager.getEmployeeUserMap();
                        let screenContext = self.state.screenContext;
                        screenContext.groupKey = self.defaultGroupKey;

                        if (self.hasDistricts || self.state.isGroupsMode) {
                            screenContext.groupKey = filter.metricNameDistrict;
                        }

                        if (userInfo.userType === 5) {

                            let tempKeys = Object.keys(data);
                            for (var i = 0; i < tempKeys.length; i++) {
                                if (tempKeys[i] != 'totals' && data[tempKeys[i]].length > 0 &&
                                    data[tempKeys[i]][0].userId != null &&
                                    data[tempKeys[i]][0].userId.toLowerCase() === userInfo.userId.toLowerCase()) {

                                    self.state.screenContext.groupKey = tempKeys[i];
                                    filter.nameAllEmployee = tempKeys[i];
                                    self.meKey = tempKeys[i];

                                    break;

                                }
                            }
                        }

                        self.setState({
                            companyId: companyId,
                            allStoreIDs: allStoreIDs,
                            userId: userId,
                            userType: userInfo.userType,
                            blastFilter: filter,
                            blastData: data,
                            screenContext: screenContext,
                            lastBlastReload: lastUpdate,
                            canCreateMetricGroups: userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].canCreateMetricGroups
                        }, () => {

                            //if (data === undefined || data === null || data.length === 0) {
                            self.props.loadingOff();
                            //}

                            if (!self.props.isPhone) {
                                self.loadPeekData();
                            }

                            self.loadGoalsContests();
                            self.props.blastService.subscribe({
                                companyId: self.state.blastFilter.companyId,
                                storeIds: self.state.allStoreIDs,
                                userId: self.state.userId,
                                userTypeId: self.state.userType,
                                filterDate: self.state.blastFilter.date
                            }, (subLastUpdate) => {
                                self.blastSubCallback(subLastUpdate);
                            }, (storeIds) => {

                            });
                        });
                    });
                }

                if (!self.state.isGroupsMode) {

                    self.blastDataManager.loadBlastData([{
                        companyId: companyId,
                        storeIds: allStoreIDs,
                        userId: userId,
                        userTypeId: userInfo.userType,
                        filterDate: filter.date
                    }], blastDataCallback, (err) => {
                        self.loadingOff();
                    });
                } else {
                    self.blastDataManager.loadGroupsBlastData([{
                        companyId: companyId,
                        storeIds: allStoreIDs,
                        userId: userId,
                        userTypeId: userInfo.userType,
                        filterDate: filter.date
                    }], blastDataCallback, (err) => {
                        self.loadingOff();
                    });
                }

            } else {
                self.props.loadingOff();
            }
        }, (err) => {
            self.props.loadingOff();
        });
    }


    refresh() {
        this.props.blastService.refreshBlastData(() => {

        });
    }

    async loadBlastData(blastFilter, screen, callback) {
       try {
            let self = this;

            let allListObj = await self.blastDataManager.getAllLists(blastFilter);
            let listNames = ['districtMetricList', 'districtLocationMetricList', 'locationMetricList', 'employeeMetricList', 'employeeMetricList',
                'districtList', 'districtLocationList', 'locationList', 'employeeList', 'allEmployeeList'];
            let filterNames = ['metricNameDistrict', 'metricNameDistrictLocation', 'metricNameLocation', 'metricNameEmployee', 'metricNameAllEmployee',
                'nameDistrict', 'nameDistrictLocation', 'nameLocation', 'nameEmployee', 'nameAllEmployee'];

            for (var i = 0; i < listNames.length; i++) {
                self[listNames[i]] = allListObj[listNames[i]];
                if (blastFilter[filterNames[i]] === undefined) {
                    blastFilter[filterNames[i]] = self[listNames[i]][0];
                }
            }

            if (blastFilter !== undefined) {
                switch (screen) {
                    case "locs":
                        self.defaultGroupKey = blastFilter.metricNameLocation;
                        self.blastDataManager.getLocationsData(blastFilter, callback);
                        break;
                    case "loc":
                        self.blastDataManager.getLocationData(blastFilter, callback)
                        break;
                    case "emps":
                        self.blastDataManager.getEmployeesData(blastFilter, callback);
                        break;
                    case "emp":
                        self.blastDataManager.getEmployeeData(blastFilter, callback);
                        break;
                    case "allemps":
                        self.blastDataManager.getAllEmployeesData(blastFilter, callback);
                        break;
                    case "allemp":
                        self.blastDataManager.getAllEmployeeData(blastFilter, callback);
                        break;
                    case "dists":
                        self.blastDataManager.getDistrictsData(blastFilter, callback);
                        break;
                    case "dist":
                        self.blastDataManager.getDistrictData(blastFilter, callback);
                        break;
                    case "distLocs":
                        self.blastDataManager.getDistrictLocationsData(blastFilter, callback);
                        break;
                    case "distLoc":
                        self.blastDataManager.getDistrictLocationData(blastFilter, callback);
                        break;
                    default:
                        callback(null);
                        break;
                }
            }
        } catch(error) {
            alert(this.errmsg);
        }  
    }

    loadBlastDataAgain(callback) {
        var self = this;

        let filter = this.state.blastFilter;

        let blastDataCallback = (lastUpdate) => {
            self.loadBlastData(filter, self.state.screenContext.screen, (data) => {

                self.getPhoneNumbers(filter);

                let screenContext = self.state.screenContext;
                let dataKeys = Object.keys(data);
                if (!dataKeys.includes(screenContext.groupKey) && dataKeys.length >= 1 && dataKeys[0] != "totals") {
                    screenContext.groupKey = dataKeys[0];
                }

                self.setState({
                    screenContext: screenContext,
                    blastFilter: filter,
                    blastData: data,
                    lastBlastReload: lastUpdate
                }, () => {
                    self.changingDate = false;

                    if (callback) {
                        callback();
                    }

                    self.props.loadingOff();
                    self.loadGoalsContests();

                    if (!self.props.isPhone) {
                        self.loadPeekData();
                    }

                    if (moment().format("MM/DD/YYYY") === filter.date && !self.state.isGroupsMode) {
                        self.props.blastService.subscribe({
                            companyId: self.state.blastFilter.companyId,
                            storeIds: self.state.allStoreIDs,
                            userId: self.state.userId,
                            userTypeId: self.state.userType,
                            filterDate: self.state.blastFilter.date
                        }, (subLastUpdate) => {
                            self.blastSubCallback(subLastUpdate);
                        }, (storeIds) => {
                        });
                    }
                });
            }, (err) => {
                self.changingDate = false;
                self.props.loadingOff();
            });
        }

        if (!self.state.isGroupsMode) {
            self.blastDataManager.loadBlastData([{
                companyId: self.state.companyId,
                storeIds: self.state.allStoreIDs,
                userId: self.state.userId,
                filterDate: filter.date,
                userTypeId: self.state.userType,
            }], blastDataCallback, (err) => {
                self.changingDate = false;
                self.props.loadingOff();
            });
        } else {
            self.blastDataManager.loadGroupsBlastData([{
                companyId: self.state.companyId,
                storeIds: self.state.allStoreIDs,
                userId: self.state.userId,
                filterDate: filter.date,
                userTypeId: self.state.userType,
            }], blastDataCallback, (err) => {
                self.changingDate = false;
                self.props.loadingOff();
            });
        }
    }

    loadBlastDataAgainSimple() {
        var self = this;

        self.loadBlastData(this.state.blastFilter, self.state.screenContext.screen, (data) => {

            self.setState({
                blastData: data
            }, () => {
                self.props.loadingOff();

                if (!self.props.isPhone) {
                    self.loadPeekData();
                }
            });
        }, (err) => {
            self.props.loadingOff();
        });
    }

    promptForLongData(dataIdentity) {
        let self = this;

        let kpiName = dataIdentity.kPIName;
        let dataSpecifier = dataIdentity.name;

        let isBlurred = false;
        if (this.state.accountInfo != undefined && this.state.accountInfo != null && this.state.accountInfo.userType === 5) {
            isBlurred = this.state.accountInfo.isEmployeeBlurred === null ? false : this.state.accountInfo.isEmployeeBlurred;
        }

        let locked = false;
        if (isBlurred && ["emps", "emp", "allemps", "allemp"].includes(self.state.screenContext.screen) && zzDataCache.myDataName != dataIdentity.name) {
            locked = true;
        }

        if (!locked) {

            zconfirm((
                <div className={"metrics-longitude-asker"}>
                    <div className={"header"}>{"Metric Analysis"}</div>
                    <div className={"sub-header"}>{"Run a deeper analysis of " + kpiName + " for " + dataSpecifier}</div>
                </div>
            ), () => {

                let blastLongitudeFilter = {
                    clientAccountId: self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
                    reportKpiId: dataIdentity.reportKpiId,
                    endDate: self.state.blastFilter.date,
                    averageGroups: dataIdentity.isAvg || dataIdentity.type === "PCT"
                }
                if (["dists", "dist"].includes(self.state.screenContext.screen)) {
                    blastLongitudeFilter.districtId = dataIdentity.districtId;

                } else if (["distLocs", "distLoc", "locs", "loc"].includes(self.state.screenContext.screen)) {
                    blastLongitudeFilter.locationId = dataIdentity.locationId;

                } else if (["emps", "emp"].includes(self.state.screenContext.screen)) {
                    blastLongitudeFilter.locationId = dataIdentity.locationId;
                    blastLongitudeFilter.employeeName = dataIdentity.name;
                } else if (["allemps", "allemp"].includes(self.state.screenContext.screen)) {
                    blastLongitudeFilter.employeeName = dataIdentity.name;
                    if (dataIdentity.employeeUniqueName != null && dataIdentity.employeeUniqueName != undefined && dataIdentity.employeeUniqueName != "") {
                        blastLongitudeFilter.employeeUniqueName = dataIdentity.employeeUniqueName;
                    }
                }
                self.props.loadingOn(() => {
                    self.broadcastService.blastLongitude(blastLongitudeFilter, longData => {

                        self.props.loadingOff(() => {
                            alert((
                                <LongitudinalDataDisplay
                                    kpiName={kpiName}
                                    dataSpecifier={dataSpecifier}
                                    data={longData}
                                    sumMode={!(dataIdentity.isAvg || dataIdentity.type === "PCT")}
                                    isAvg={dataIdentity.isAvg || dataIdentity.type === "PCT"}
                                    dataIdentity={dataIdentity}
                                />
                            ));
                        });
                    }, () => {
                        alert("An error occurred analyzing data. Please try again.");
                        self.props.loadingOff();
                    })
                });

            }, () => {

            }, {
                yes: "Confirm",
                no: "Cancel"
            });
        }
    }

    getPhoneNumbers(filter) {
        let self = this;

        self.blastDataManager.getEmployeePhoneNumbers(filter, (phoneNumbers) => {
            self.employeePhoneList = phoneNumbers;
        });

        self.blastDataManager.getLocationPhoneNumbers(filter, (phoneNumbers) => {
            self.locationPhoneList = phoneNumbers;
        });
    }

    setCompareMode(compareMode) {
        let self = this;
        if (compareMode != zzDataCache.settings.compareMode) {
            self.dbm.saveSetting("compareMode", compareMode);
            self.loadBlastDataAgainSimple();
        }
    }

    loadGoalsContests() {
        this.changingGoals = true;

        this.loadGoals();
        this.loadMyContests();
    }

    loadGoals() {
        let self = this;
        this.dbm.getAccountInfo().then((account) => {
            self.state.accountInfo = account;

            let goalPayload = {
                clientAccountId: account.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
                userTypeId: account.userType,
                userId: account.userId
            }

            if (account.clientAccountList.length === 0) {
                this.changingGoals = false;
                // self.props.loadingOff();
                return;
            } else if (account.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.length === 0) {
                this.changingGoals = false;
                // self.props.loadingOff();
                return;
            }

            if (self.goalTimeout != null) {
                clearTimeout(self.goalTimeout);
            }

            if (self.goalTimeoutCounter++ >= 20) {
                self.goalTimeoutCounter = 0;
                self.gcService.goalsByClientAccount(goalPayload, (res) => {
                    self.clientAccountGoals = res;
                    self.caGoalSwitch = true;
                    if (self.caGoalSwitch) {
                        self.updateActiveGoals();
                    }
                }, (err) => {
                    alert(this.errmsg)
                });
            } else {
                self.goalTimeout = setTimeout(() => {
                    self.gcService.goalsByClientAccount(goalPayload, (res) => {
                        self.clientAccountGoals = res;
                        self.caGoalSwitch = true;
                        self.goalTimeout = null;
                        if (self.caGoalSwitch) {
                            self.updateActiveGoals();
                        }
                    }, (err) => {
                        alert(this.errmsg);
                    });
                }, 1000);
            }
        });
    }

    async updateActiveGoals() {

        self.caGoalSwitch = false;
        self.lGoalSwitch = false;
        self.uGoalSwitch = false;

        let activeGoals = this.getActiveGoals();

        this.setState({ activeGoals: activeGoals });
    }

    getActiveGoals(screenContext, blastFilter, blastData) {

        if (this.clientAccountGoals === null) {
            return [];
        }

        if (screenContext === undefined) {
            screenContext = this.state.screenContext;
        }
        if (blastFilter === undefined) {
            blastFilter = this.state.blastFilter;
        }
        if (blastData === undefined) {
            blastData = this.state.blastData;
        }

        let activeGoals = [];

        switch (screenContext.screen) {
            case 'dists':
                for (var i = 0; i < this.clientAccountGoals.length; i++) {
                    if ((this.clientAccountGoals[i].locationId === undefined || this.clientAccountGoals[i].locationId === null) &&
                        (this.clientAccountGoals[i].userId === undefined || this.clientAccountGoals[i].userId === null) &&
                        ((new Date(blastFilter.date)).getTime() <= (new Date(this.clientAccountGoals[i].toDate)).getTime() &&
                            (new Date(blastFilter.date)).getTime() >= (new Date(this.clientAccountGoals[i].fromDate)).getTime())) {
                        activeGoals.push(this.clientAccountGoals[i]);
                    }
                }
                break;
            case 'locs':
                for (var i = 0; i < this.clientAccountGoals.length; i++) {
                    if ((this.clientAccountGoals[i].locationId === undefined || this.clientAccountGoals[i].locationId === null) &&
                        (this.clientAccountGoals[i].userId === undefined || this.clientAccountGoals[i].userId === null) &&
                        ((new Date(blastFilter.date)).getTime() <= (new Date(this.clientAccountGoals[i].toDate)).getTime() &&
                            (new Date(blastFilter.date)).getTime() >= (new Date(this.clientAccountGoals[i].fromDate)).getTime())) {
                        activeGoals.push(this.clientAccountGoals[i]);
                    }
                }
                break;
            case 'loc':
                for (var i = 0; i < this.clientAccountGoals.length; i++) {
                    if ((this.locationMap[this.clientAccountGoals[i].locationId] === screenContext.groupKey) &&
                        (this.clientAccountGoals[i].locationId != undefined && this.clientAccountGoals[i].locationId != null) &&
                        (this.clientAccountGoals[i].userId === undefined || this.clientAccountGoals[i].userId === null) &&
                        ((new Date(blastFilter.date)).getTime() <= (new Date(this.clientAccountGoals[i].toDate)).getTime() &&
                            (new Date(blastFilter.date)).getTime() >= (new Date(this.clientAccountGoals[i].fromDate)).getTime())) {
                        activeGoals.push(this.clientAccountGoals[i]);
                    }
                }
                break;
            case 'distLoc':
                for (var i = 0; i < this.clientAccountGoals.length; i++) {
                    if ((this.locationMap[this.clientAccountGoals[i].locationId] === screenContext.groupKey) &&
                        (this.clientAccountGoals[i].locationId != undefined && this.clientAccountGoals[i].locationId != null) &&
                        (this.clientAccountGoals[i].userId === undefined || this.clientAccountGoals[i].userId === null) &&
                        ((new Date(blastFilter.date)).getTime() <= (new Date(this.clientAccountGoals[i].toDate)).getTime() &&
                            (new Date(blastFilter.date)).getTime() >= (new Date(this.clientAccountGoals[i].fromDate)).getTime())) {
                        activeGoals.push(this.clientAccountGoals[i]);
                    }
                }
                break;
            case 'emps':

                if (blastData[screenContext.groupKey] != undefined) {
                    this.userMap = blastData[screenContext.groupKey].reduce((r, e) => {
                        let key = e.userId;
                        if (!r[key] && e.userId != undefined && e.userId != null) {
                            r[key] = e.name;
                        }

                        return r;
                    }, {})


                    for (var i = 0; i < this.clientAccountGoals.length; i++) {
                        if ((this.locationMap[this.clientAccountGoals[i].locationId] === blastFilter.nameLocation) &&
                            (this.clientAccountGoals[i].locationId != undefined && this.clientAccountGoals[i].locationId != null) &&
                            (this.clientAccountGoals[i].userId === undefined || this.clientAccountGoals[i].userId === null) &&
                            ((new Date(blastFilter.date)).getTime() <= (new Date(this.clientAccountGoals[i].toDate)).getTime() &&
                                (new Date(blastFilter.date)).getTime() >= (new Date(this.clientAccountGoals[i].fromDate)).getTime())) {
                            activeGoals.push(this.clientAccountGoals[i]);
                        }
                    }
                }
                break;
            case 'emp':
                for (var i = 0; i < this.clientAccountGoals.length; i++) {
                    if ((this.clientAccountGoals[i].blastData.length > 0 ?
                        this.clientAccountGoals[i].blastData[0].name === screenContext.groupKey
                        :
                        this.userMap[this.clientAccountGoals[i].userId] === screenContext.groupKey
                    ) &&
                        (this.clientAccountGoals[i].locationId != undefined && this.clientAccountGoals[i].locationId != null) &&
                        (this.clientAccountGoals[i].userId != undefined && this.clientAccountGoals[i].userId != null) &&
                        ((new Date(blastFilter.date)).getTime() <= (new Date(this.clientAccountGoals[i].toDate)).getTime() &&
                            (new Date(blastFilter.date)).getTime() >= (new Date(this.clientAccountGoals[i].fromDate)).getTime())) {


                        activeGoals.push(this.clientAccountGoals[i]);
                    }
                }
                break;
            case 'allemps':

                if (blastData[screenContext.groupKey] != undefined) {
                    this.userMap = blastData[screenContext.groupKey].reduce((r, e) => {
                        let key = e.userId;
                        if (!r[key] && e.userId != undefined && e.userId != null) {
                            r[key] = e.name;
                        }

                        return r;
                    }, {})
                }
                break;
            case 'allemp':
                for (var i = 0; i < this.clientAccountGoals.length; i++) {
                    if ((this.clientAccountGoals[i].blastData.length > 0 && this.userMap[this.clientAccountGoals[i].userId] != screenContext.groupKey ?
                        this.clientAccountGoals[i].blastData[0].name === screenContext.groupKey
                        :
                        this.userMap[this.clientAccountGoals[i].userId] === screenContext.groupKey
                    ) &&
                        (this.clientAccountGoals[i].locationId != undefined && this.clientAccountGoals[i].locationId != null) &&
                        (this.clientAccountGoals[i].userId != undefined && this.clientAccountGoals[i].userId != null) &&
                        ((new Date(blastFilter.date)).getTime() <= (new Date(this.clientAccountGoals[i].toDate)).getTime() &&
                            (new Date(blastFilter.date)).getTime() >= (new Date(this.clientAccountGoals[i].fromDate)).getTime())) {
                        activeGoals.push(this.clientAccountGoals[i]);
                    }
                }
                break;
        }

        this.changingGoals = false;

        if (screenContext.screen != "allemp" && screenContext.screen != "allemps" && screenContext.screen != "emps") {
            this.overwriteGoalData(activeGoals);
        }

        return activeGoals;
    }

    overwriteGoalData(goals) {

        goals.forEach((identity) => {
            identity.blastData.forEach((idBlast) => {

                if (idBlast.dateIndex === parseInt(moment(this.state.blastFilter.date).format('YYYYMMDD'))) {

                    let relevantData = [];
                    let relevantTotal = 0;
                    let isAvg = false;
                    let keys = Object.keys(this.state.blastData);
                    for (var i = 0; i < keys.length; i++) {
                        if (keys[i] != 'totals') {
                            this.state.blastData[keys[i]].forEach((blast) => {
                                let relSwitch = false;
                                if (identity.userId != null) {
                                    if (blast.userId === identity.userId &&
                                        (this.storeMap[blast.storeId] === this.locationMap[identity.locationId] || blast.locationId === identity.locationId)) {
                                        relSwitch = true;
                                    }
                                } else if (identity.locationId != null) {
                                    if (this.storeMap[blast.storeId] === this.locationMap[identity.locationId]) {
                                        relSwitch = true;
                                    }
                                } else {
                                    relSwitch = true;
                                }

                                if (relSwitch && identity.metricName.trim() === blast.kPIName.trim()) {
                                    isAvg = blast.isAvg;
                                    switch (identity.timeFrame) {
                                        case 'Day': relevantData.push(blast.cData.CUR); relevantTotal += blast.cData.CUR; break;
                                        case 'Week': relevantData.push(blast.cData.WTD); relevantTotal += blast.cData.WTD; break;
                                        case 'Month': relevantData.push(blast.cData.MTD); relevantTotal += blast.cData.MTD; break;
                                        case 'Quarter': relevantData.push(blast.cData.QTD); relevantTotal += blast.cData.QTD; break;
                                        case 'Year': relevantData.push(blast.cData.YTD); relevantTotal += blast.cData.YTD; break;
                                    }
                                }
                            });
                        }
                    }

                    let result = relevantTotal;
                    if (isAvg) {
                        result = result / parseFloat(relevantData.length);
                    }

                    idBlast.cyValue = result;
                }
            });
        });
    }

    loadMyContests() {
        let self = this;

        let storedClientAccount = zzDataCache.account.clientAccountList[zzDataCache.settings.selectedClientAccountIndex];
        let storedLocationIds = storedClientAccount.locations.reduce((r, e) => { r.push(e.locationID); return r; }, []);
        let filterDate = self.state.blastFilter.date;
        let payload = {
            clientAccountId: storedClientAccount.clientAccountId,
            locationIds: storedLocationIds,
            dateIndex: parseInt(filterDate.substring(6, 10) + filterDate.substring(0, 2) + filterDate.substring(3, 5))
        }

        self.contestService.getMyContests(payload, (contestMultiLoadedItem) => {
            let allContests = [];

            contestMultiLoadedItem.rankedContests.forEach(contest => {
                contest.contest.groupName = contest.groupName;
                contest.contest.masterKpiNames = contest.masterKpiNames;
                contest.contest.reportKpiIds = contest.contest.metricReportKpiId != null ? [contest.contest.metricReportKpiId] : [];
                allContests.push({
                    contestId: contest.contest.rankedContestId,
                    type: "ranked",
                    identity: contest.contest,
                    hasData: contest.data.length > 0,
                    data: contest.data,
                });
            });
            contestMultiLoadedItem.raffleContests.forEach(contest => {
                contest.contest.groupName = contest.groupName;
                contest.contest.masterKpiNames = contest.masterKpiNames;
                contest.contest.reportKpiIds = [];
                if (contest.contest.metricOneReportKpiId != null) { contest.contest.reportKpiIds.push(contest.contest.metricOneReportKpiId) }
                if (contest.contest.metricTwoReportKpiId != null) { contest.contest.reportKpiIds.push(contest.contest.metricTwoReportKpiId) }
                if (contest.contest.metricThreeReportKpiId != null) { contest.contest.reportKpiIds.push(contest.contest.metricThreeReportKpiId) }


                let totalTicketCount = 0;
                let tmpData = contest.data.reduce((r, e) => {
                    let key = e.entityName;
                    if (!r[key]) {
                        r[key] = 0;
                    }
                    r[key] += e.ticketCount;
                    totalTicketCount += e.ticketCount;

                    return r;
                }, {})

                let tmpLongData = contest.data.reduce((r, e) => {
                    let key = e.entityName;
                    if (!r[key]) {
                        r[key] = {};
                    }

                    let diKey = e.dateIndex;
                    if (!r[key][diKey]) {
                        r[key][diKey] = { ticketCount: 0, dateIndex: e.dateIndex }
                    }

                    r[key][diKey].ticketCount += e.ticketCount;

                    return r;
                }, {})
                Object.keys(tmpLongData).forEach(key => {

                    let tmpArr = [];
                    Object.keys(tmpLongData[key]).forEach(diKey => {
                        tmpArr.push(tmpLongData[key][diKey]);
                    })

                    tmpLongData[key] = _.sortBy(tmpArr, x => x.dateIndex);
                });

                let tmpTicketRankedData = _.sortBy(Object.values(contest.data.reduce((r, e) => {
                    let key = e.entityName;
                    if (!r[key]) {
                        r[key] = { entityName: key, entitySubName: e.entitySubName, ticketCount: 0 };
                    }
                    r[key].ticketCount += e.ticketCount;

                    return r;
                }, {})), x => x.ticketCount).reverse().slice(0, 5);

                allContests.push({
                    contestId: contest.contest.raffleContestId,
                    type: "raffle",
                    identity: contest.contest,
                    hasData: contest.data.length > 0,
                    data: tmpData,
                    longData: tmpLongData,
                    rankedData: tmpTicketRankedData,
                    totalTicketCount: totalTicketCount
                });
            });

            self.allContests = allContests;
            self.updateActiveContests();

        }, (err) => {
            alert(this.errmsg)
        })
    }

    async updateActiveContests() {

        let activeContests = this.getActiveContests();

        this.setState({ activeContests: activeContests });
    }

    getActiveContests(screenContext, blastFilter, blastData) {

        if (screenContext === undefined) {
            screenContext = this.state.screenContext;
        }
        if (blastFilter === undefined) {
            blastFilter = this.state.blastFilter;
        }
        if (blastData === undefined) {
            blastData = this.state.blastData;
        }

        if (blastData === null || blastData === undefined || screenContext === null || screenContext === undefined ||
            screenContext.groupKey === null || screenContext.groupKey === undefined ||
            blastData[screenContext.groupKey] === null || blastData[screenContext.groupKey] === undefined ||
            blastData[screenContext.groupKey].length === 0) {
            return [];
        }

        let testDataList = blastData[screenContext.groupKey];
        let testDataObj = testDataList[0];
        let ctxLocationId = testDataObj.locationId;
        let ctxReportKpiId = testDataObj.reportKpiId;
        let ctxReportKpiName = testDataObj.kPIName.trim();
        let ctxName = testDataObj.name;
        let ctxDistrictName = testDataObj.districtName;

        let ctxLocationIdList = testDataList.reduce((r, e) => { r.push(e.locationId); return r; }, [])

        let allContests = this.allContests;

        let contestObj = allContests.reduce((r, e) => {

            if (e.identity.groupId === null && e.identity.locationId === null) {
                r.ca.push(e);
            } else if (e.identity.locationId != null) {
                r.loc.push(e);
            } else if (e.identity.groupId != null) {
                r.group.push(e);
            }

            return r;
        },
            {
                ca: [],
                loc: [],
                group: []
            }
        );


        let activeContests = [];
        switch (screenContext.screen) {
            case 'dists':
                contestObj.group.forEach(contest => {
                    if (contest.identity.masterKpiNames.includes(ctxReportKpiName) && contest.hasData) {
                        activeContests.push(contest);
                    }
                });
                break;
            case 'dist':
                contestObj.group.forEach(contest => {
                    if (contest.identity.groupName === ctxDistrictName && contest.hasData) {
                        activeContests.push(contest);
                    }
                });
                break;
            case 'distLocs':
                contestObj.loc.forEach(contest => {
                    if (ctxLocationIdList.includes(contest.identity.locationId) && contest.identity.masterKpiNames.includes(ctxReportKpiName) && contest.hasData) {
                        activeContests.push(contest);
                    }
                })
                break;
            case 'distLoc':
                contestObj.group.forEach(contest => {

                    if (contest.identity.participantType === "loc") {

                        let nameMatch = false
                        if (contest.type === "ranked") {
                            nameMatch = contest.data.reduce((r, e) => { r.push(e.entityName); return r; }, []).includes(ctxName);
                        } else if (contest.type === "raffle") {
                            nameMatch = Object.keys(contest.data).includes(ctxName);
                        }

                        if (nameMatch && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                contestObj.ca.forEach(contest => {

                    if (contest.identity.participantType === "loc") {

                        let nameMatch = false
                        if (contest.type === "ranked") {
                            nameMatch = contest.data.reduce((r, e) => { r.push(e.entityName); return r; }, []).includes(ctxName);
                        } else if (contest.type === "raffle") {
                            nameMatch = Object.keys(contest.data).includes(ctxName);
                        }

                        if (nameMatch && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                contestObj.loc.forEach(contest => {
                    if (contest.identity.locationId === ctxLocationId && contest.hasData) {
                        activeContests.push(contest);
                    }
                });
                break;
            case 'locs':
                contestObj.ca.forEach(contest => {
                    if (contest.identity.masterKpiNames.includes(ctxReportKpiName) && contest.hasData) {
                        activeContests.push(contest);
                    }
                });
                break;
            case 'loc':
                contestObj.group.forEach(contest => {

                    if (contest.identity.participantType === "loc") {

                        let nameMatch = false
                        if (contest.type === "ranked") {
                            nameMatch = contest.data.reduce((r, e) => { r.push(e.entityName); return r; }, []).includes(ctxName);
                        } else if (contest.type === "raffle") {
                            nameMatch = Object.keys(contest.data).includes(ctxName);
                        }

                        if (nameMatch && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                contestObj.ca.forEach(contest => {

                    if (contest.identity.participantType === "loc") {

                        let nameMatch = false
                        if (contest.type === "ranked") {
                            nameMatch = contest.data.reduce((r, e) => { r.push(e.entityName); return r; }, []).includes(ctxName);
                        } else if (contest.type === "raffle") {
                            nameMatch = Object.keys(contest.data).includes(ctxName);
                        }

                        if (nameMatch && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                contestObj.loc.forEach(contest => {
                    if (contest.identity.locationId === ctxLocationId && contest.hasData) {
                        activeContests.push(contest);
                    }
                });
                break;
            case 'emps':
                contestObj.loc.forEach(contest => {

                    if (contest.identity.participantType === "emp") {

                        if (contest.identity.reportKpiIds.includes(ctxReportKpiId) && contest.identity.locationId === ctxLocationId && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                break;
            case 'emp':
                contestObj.ca.forEach(contest => {

                    if (contest.identity.participantType === "emp") {

                        let nameMatch = false
                        if (contest.type === "ranked") {
                            nameMatch = contest.data.reduce((r, e) => { r.push(e.entityName); return r; }, []).includes(ctxName);
                        } else if (contest.type === "raffle") {
                            nameMatch = Object.keys(contest.data).includes(ctxName);
                        }

                        if (nameMatch && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                contestObj.group.forEach(contest => {

                    if (contest.identity.participantType === "emp") {

                        let nameMatch = false
                        if (contest.type === "ranked") {
                            nameMatch = contest.data.reduce((r, e) => { r.push(e.entityName); return r; }, []).includes(ctxName);
                        } else if (contest.type === "raffle") {
                            nameMatch = Object.keys(contest.data).includes(ctxName);
                        }

                        if (nameMatch && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                contestObj.loc.forEach(contest => {

                    if (contest.identity.participantType === "emp") {

                        let nameMatch = false
                        if (contest.type === "ranked") {
                            nameMatch = contest.data.reduce((r, e) => { r.push(e.entityName); return r; }, []).includes(ctxName);
                        } else if (contest.type === "raffle") {
                            nameMatch = Object.keys(contest.data).includes(ctxName);
                        }

                        if (nameMatch && contest.identity.locationId === ctxLocationId && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                break;
            case 'allemps':
                contestObj.ca.forEach(contest => {

                    if (contest.identity.participantType === "emp") {

                        if (contest.identity.reportKpiIds.includes(ctxReportKpiId) && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                contestObj.loc.forEach(contest => {

                    if (contest.identity.participantType === "emp") {

                        if (contest.identity.reportKpiIds.includes(ctxReportKpiId) && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                contestObj.group.forEach(contest => {

                    if (contest.identity.participantType === "emp") {

                        if (contest.identity.reportKpiIds.includes(ctxReportKpiId) && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                break;
            case 'allemp':
                contestObj.ca.forEach(contest => {

                    if (contest.identity.participantType === "emp") {

                        let nameMatch = false
                        if (contest.type === "ranked") {
                            nameMatch = contest.data.reduce((r, e) => { r.push(e.entityName); return r; }, []).includes(ctxName);
                        } else if (contest.type === "raffle") {
                            nameMatch = Object.keys(contest.data).includes(ctxName);
                        }

                        if (nameMatch && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                contestObj.loc.forEach(contest => {

                    if (contest.identity.participantType === "emp") {

                        let nameMatch = false
                        if (contest.type === "ranked") {
                            nameMatch = contest.data.reduce((r, e) => { r.push(e.entityName); return r; }, []).includes(ctxName);
                        } else if (contest.type === "raffle") {
                            nameMatch = Object.keys(contest.data).includes(ctxName);
                        }

                        if (nameMatch && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                contestObj.group.forEach(contest => {

                    if (contest.identity.participantType === "emp") {

                        let nameMatch = false
                        if (contest.type === "ranked") {
                            nameMatch = contest.data.reduce((r, e) => { r.push(e.entityName); return r; }, []).includes(ctxName);
                        } else if (contest.type === "raffle") {
                            nameMatch = Object.keys(contest.data).includes(ctxName);
                        }

                        if (nameMatch && contest.hasData) {
                            activeContests.push(contest);
                        }
                    }
                });
                break;
        }

        return activeContests;
    }

    changeDate(dateString, dateObject, event) {
        this.props.blastService.track(this.state.blastFilter.companyId, this.state.blastFilter.storeId, this.state.screenContext.groupKey, 'inspectDate', dateString)
        this.changingDate = true;
        this.props.loadingOn();

        let filter = this.state.blastFilter;
        filter.date = moment(dateObject).format("MM/DD/YYYY");

        let self = this;

        self.props.onlineStatusFirst(() => {
            if (moment().format("MM/DD/YYYY") === filter.date) {

                self.setState({ blastFilter: filter, selectedItems: [] }, () => {
                    self.loadBlastDataAgain();
                });
            } else {
                self.props.blastService.unsubscribeAll(() => {
                    self.setState({ blastFilter: filter, selectedItems: [] }, () => {
                        self.loadBlastDataAgain();
                    });
                }, () => {
                    self.setState({ blastFilter: filter, selectedItems: [] }, () => {
                        self.loadBlastDataAgain();
                    });
                });
            }
        });
    }

    changeSort(sortBy, sortByDir) {
        let filter = this.state.blastFilter;
        filter.sortBy = sortBy;
        filter.sortByDir = sortByDir;
        this.props.blastService.track(this.state.blastFilter.companyId, this.state.blastFilter.storeId, this.state.screenContext.groupKey, 'sort', sortBy)


        window.localStorage.setItem('metricSortBy', sortBy);
        window.localStorage.setItem('metricSortByDir', sortByDir);

        this.setState({ blastFilter: filter });
    }

    rotateSort() {
        let filter = this.state.blastFilter;
        let sortBy = 'NAME';
        switch (filter.sortBy) {
            case 'NAME': sortBy = 'cY';
                break;
            case 'cY': sortBy = 'lY';
                break;
            case 'lY': sortBy = 'NAME';
                break;
        }
        filter.sortBy = sortBy;

        window.localStorage.setItem('metricSortBy', sortBy);

        this.setState({ blastFilter: filter });
    }

    rotateSortDir() {
        let filter = this.state.blastFilter;
        let sortDir = 'DESC';
        if (filter.sortByDir === 'DESC') {
            sortDir = 'ASC';
        }
        filter.sortByDir = sortDir;

        window.localStorage.setItem('metricSortByDir', sortDir);

        this.setState({ blastFilter: filter });
    }

    rotateFilter() {
        switch (this.state.searchTop) {
            case 0: this.setState({ searchTop: 10 });
                break;
            case 10: this.setState({ searchTop: 25 });
                break;
            case 25: this.setState({ searchTop: 100 });
                break;
            case 100: this.setState({ searchTop: 0 });
                break;
        }
    }

    rotateDataMode() {
        let filter = this.state.blastFilter;
        let newMode = '';
        switch (filter.dataMode) {
            case 'D':
                newMode = 'P';
                this.props.blastService.track(this.state.blastFilter.companyId, this.state.blastFilter.storeId, this.state.screenContext.groupKey, 'compareMode', '%')
                break;
            case 'P':
                newMode = 'N';
                this.props.blastService.track(this.state.blastFilter.companyId, this.state.blastFilter.storeId, this.state.screenContext.groupKey, 'compareMode', '$')
                break;
            default:
                newMode = 'D';
                this.props.blastService.track(this.state.blastFilter.companyId, this.state.blastFilter.storeId, this.state.screenContext.groupKey, 'compareMode', '+/-')
                break;
        }
        filter.dataMode = newMode;
        this.setState({ blastFilter: filter });
    }

    updateBlastFilter(filter) {
        this.setState({ blastFilter: filter });
    }

    handleForceBlast() {
        this.refresh();
    }

    handleScrollTop(isScrollTop, scrollTop) {
        if (this.state.isScrollTop != isScrollTop) {
            this.scrollTop = scrollTop;
            this.setState({ isScrollTop: isScrollTop });
        }
    }

    scrollToTop(event) {
        //$(".metrics-central-outer")[0].scrollTo(0, 0);
        $('.metrics-central-outer').animate({ scrollTop: 0 }, 400);
    }

    handleScrollDirection(isScrollDirectionDown) {
        if (this.state.isScrollDirectionDown != isScrollDirectionDown) {
            if (!this.state.isSearchMode) {
                this.setState({ isScrollDirectionDown: isScrollDirectionDown }, () => {

                });
            } else {
                this.setState({ isScrollDirectionDown: isScrollDirectionDown, isSearchMode: false }, () => {

                });
            }
        }
    }

    toggleSelectedItem(item) {

        if (this.state.screenContext.isMetric) {
            return;
        }

        var wasThere = false;
        var selectedItems = this.state.selectedItems;
        for (var i = 0; i < selectedItems.length; i++) {
            if (item.name === selectedItems[i].name) {
                wasThere = true;
                selectedItems.splice(i--, 1);
            }
        }
        if (!wasThere) {
            selectedItems.push(item);
        }

        if (!this.props.isPhone && this.state.rightOptions.peek.solo) {
            selectedItems = [item];
        }

        this.setState({ selectedItems: selectedItems });
    }

    clearSelectedItems() {
        this.setState({ selectedItems: [] });
    }

    selectAllItems() {
        if (this.state.screenContext.groupKey === undefined ||
            this.state.blastData[this.state.screenContext.groupKey] === undefined) {
            return null;
        }

        let allItems = [];

        this.state.blastData[this.state.screenContext.groupKey].forEach((obj) => {
            allItems.push(obj);
        });

        this.setState({ selectedItems: allItems });
    }

    toggleSearch(dir) {
        this.setState({ isSearchMode: !this.state.isSearchMode });
    }

    handleSearch(value, event) {

        this.props.handleEasterEgg(value);

        this.setState({ searchText: value });
    }

    handleSearchTop(value) {
        this.setState({ searchTop: value });
    }

    handleChangeTopSelector(name) {
        let self = this;
        if (this.isLocked()) {
            this.changeScreenLocked(name);
        } else {
            let screenContext = this.state.screenContext;
            screenContext.groupKey = name;
            this.setState({ screenContext: screenContext, activeGoals: [], activeContests: [] }, () => {
                if (!this.props.isPhone) {
                    this.loadPeekData();
                }

                self.updateActiveGoals();
                self.updateActiveContests();
            });
        }
    }

    handleChangePeekTopSelector(name) {
        let self = this;

        let peekScreenContext = this.state.peekScreenContext;
        if (peekScreenContext != null) {
            peekScreenContext.groupKey = name;
            this.setState({ peekScreenContext: peekScreenContext });
        }
    }

    setScreenContext(screen, blastFilter) {
        let screenContext = JSON.parse(JSON.stringify(this.state.screenContext));

        if (screen !== undefined) {
            screenContext.screen = screen;
        }

        switch (screen) {
            case 'locs':
                screenContext.isMetric = false;
                screenContext.hasCharts = true;
                screenContext.headerText = "Locations";
                screenContext.groupKey = blastFilter.metricNameLocation;
                screenContext.activeList = "locationMetricList";
                screenContext.showBack = false;
                this.props.blastService.track(blastFilter.companyId, blastFilter.storeId, "ALL STORES", 'inspectMetric', this.state.screenContext.groupKey)
                break;
            case 'loc':
                screenContext.isMetric = true;
                screenContext.hasCharts = false;
                screenContext.headerText = "Location";
                screenContext.groupKey = blastFilter.nameLocation;
                screenContext.activeList = "locationList";
                screenContext.showBack = true;
                this.props.blastService.track(blastFilter.companyId, blastFilter.storeId, this.state.screenContext.groupKey, 'inspectStore', this.state.screenContext.groupKey)
                break;
            case 'emps':
                screenContext.isMetric = false;
                screenContext.hasCharts = true;
                screenContext.headerText = "Employees";
                screenContext.groupKey = blastFilter.metricNameEmployee;
                screenContext.activeList = "employeeMetricList";
                screenContext.showBack = true;
                this.props.blastService.track(blastFilter.companyId, blastFilter.storeId, "PEEPS", 'inspectMetric', this.state.screenContext.groupKey)
                break;
            case 'emp':
                screenContext.isMetric = true;
                screenContext.hasCharts = false;
                screenContext.headerText = "Employee";
                screenContext.groupKey = blastFilter.nameEmployee;
                screenContext.activeList = "employeeList";
                screenContext.showBack = true;
                this.props.blastService.track(blastFilter.companyId, blastFilter.storeId, this.state.screenContext.groupKey, 'inspectPeeps', this.state.screenContext.groupKey)
                break;
            case 'allemps':
                screenContext.isMetric = false;
                screenContext.headerText = "All Employees";
                screenContext.hasCharts = true;
                screenContext.groupKey = blastFilter.metricNameAllEmployee;
                screenContext.activeList = "employeeMetricList";
                screenContext.showBack = true;
                this.props.blastService.track(blastFilter.companyId, blastFilter.storeId, "ALL PEEPS", 'inspectMetric', this.state.screenContext.groupKey)
                break;
            case 'allemp':
                screenContext.isMetric = true;
                screenContext.hasCharts = false;
                screenContext.headerText = "Employee";
                screenContext.groupKey = blastFilter.nameAllEmployee;
                screenContext.activeList = "allEmployeeList";
                screenContext.showBack = true;
                this.props.blastService.track(blastFilter.companyId, blastFilter.storeId, this.state.screenContext.groupKey, 'inspectPeeps', this.state.screenContext.groupKey)
                break;
            case 'dists':
                screenContext.isMetric = false;
                screenContext.hasCharts = !this.state.isGroupsMode;
                screenContext.headerText = this.state.isGroupsMode ? 'Groups' : 'Districts';
                screenContext.groupKey = blastFilter.metricNameDistrict;
                screenContext.activeList = "districtMetricList";
                screenContext.showBack = false;
                this.props.blastService.track(blastFilter.companyId, blastFilter.storeId, "ALL DISTRICTS", 'inspectMetric', this.state.screenContext.groupKey)
                break;
            case 'dist':
                screenContext.isMetric = true;
                screenContext.hasCharts = false;
                screenContext.headerText = this.state.isGroupsMode ? 'Group' : 'District';
                screenContext.groupKey = blastFilter.nameDistrict;
                screenContext.activeList = "districtList";
                screenContext.showBack = true;
                this.props.blastService.track(blastFilter.companyId, blastFilter.storeId, this.state.screenContext.groupKey, 'inspectStore', this.state.screenContext.groupKey)
                break;
            case 'distLocs':
                screenContext.isMetric = false;
                screenContext.hasCharts = true;
                screenContext.headerText = (this.state.isGroupsMode ? 'Group' : 'District') + " Locations";
                screenContext.groupKey = blastFilter.metricNameDistrictLocation;
                screenContext.activeList = "districtLocationMetricList";
                screenContext.showBack = true;
                this.props.blastService.track(blastFilter.companyId, blastFilter.storeId, "DISTRICT LOCATIONS", 'inspectMetric', this.state.screenContext.groupKey)
                break;
            case 'distLoc':
                screenContext.isMetric = true;
                screenContext.hasCharts = false;
                screenContext.headerText = "Location";
                screenContext.groupKey = blastFilter.nameDistrictLocation;
                screenContext.activeList = "districtLocationList";
                screenContext.showBack = true;
                this.props.blastService.track(blastFilter.companyId, blastFilter.storeId, this.state.screenContext.groupKey, 'inspectStore', this.state.screenContext.groupKey)
                break;

        }

        if (this.isLocked()) {
            screenContext.showBack = false;
        }

        return screenContext;
    }

    getChangeScreenObj(screen) {
        switch (screen) {
            case 'locs': return { list: 'locationMetricList', set: 'metricNameLocation', function: 'getLocationsData' }
                break;
            case 'loc': return { list: 'locationList', set: 'nameLocation', function: 'getLocationData' }
                break;
            case 'emps': return { list: 'employeeMetricList', set: 'metricNameEmployee', function: 'getEmployeesData' }
                break;
            case 'emp': return { list: 'employeeList', set: 'nameEmployee', function: 'getEmployeeData' }
                break;
            case 'allemps': return { list: 'employeeMetricList', set: 'metricNameAllEmployee', function: 'getAllEmployeesData' }
                break;
            case 'allemp': return { list: 'employeeList', set: 'nameAllEmployee', function: 'getAllEmployeeData' }
                break;
            case 'dists': return { list: 'districtMetricList', set: 'metricNameDistrict', function: 'getDistrictsData' }
                break;
            case 'dist': return { list: 'districtList', set: 'nameDistrict', function: 'getDistrictData' }
                break;
            case 'distLocs': return { list: 'districtLocationMetricList', set: 'metricNameDistrictLocation', function: 'getDistrictLocationsData' }
                break;
            case 'distLoc': return { list: 'districtLocationList', set: 'nameDistrictLocation', function: 'getDistrictLocationData' }
                break;
        }
    }

    doChangeScreen(newScreen, name, storeId, backward, districtId) {
        let self = this;
        let transTime = 200;

        self.setState({ drillingIn: (backward != undefined ? 'back' : 'forward') }, () => {

            let blastFilter = JSON.parse(JSON.stringify(this.state.blastFilter));

            if (!this.canSelectPeriod(blastFilter.range, newScreen)) {
                blastFilter.range = 'CUR';
            }

            if (storeId) {
                blastFilter.storeId = storeId;
            } else if (newScreen === "emps" || newScreen === "emp") {
                blastFilter.storeId = this.state.blastData[this.state.screenContext.groupKey][0].storeId;
            } else {
                blastFilter.storeId = undefined;
            }

            blastFilter.districtId = undefined;
            if (newScreen === 'distLocs' || newScreen === 'distLoc') {
                blastFilter.districtId = this.state.blastData[this.state.screenContext.groupKey][0].districtId;
            }
            if (districtId) {
                blastFilter.districtId = districtId;
            }

            if (storeId) {
                blastFilter.storeId = storeId;
            }

            let changeScreenObj = this.getChangeScreenObj(newScreen);
            let nextActiveList = changeScreenObj.list;
            let nextSetName = changeScreenObj.set;
            let blastFunctionName = changeScreenObj.function;

            self.blastDataManager.getEmployeeList(blastFilter, (employeeList) => {
                self.employeeList = employeeList;

                self.blastDataManager.getDistrictLocationList(blastFilter, (districtLocationList) => {
                    self.districtLocationList = districtLocationList;

                    if (self[nextActiveList].indexOf(name) > -1) {
                        blastFilter[nextSetName] = name;
                        if (nextSetName === 'nameDistrictLocation') {
                            blastFilter.nameLocation = name;
                        }
                    }
                    else {
                        blastFilter[nextSetName] = self[nextActiveList][0];
                        if (self[nextActiveList].length === 0) {
                            this.isScreenChanging = false;
                        }
                    }

                    blastFilter.activeList = nextActiveList;
                    let screenContext = self.setScreenContext(newScreen, blastFilter);

                    self.blastDataManager[blastFunctionName](blastFilter, (blastData) => {

                        setTimeout(() => {

                            self.curView.viewOuter.classList.add('drill-reverse');

                            $(".metrics-central-outer")[0].scrollTo(0, 0);
                            self.setState({
                                blastFilter: blastFilter,
                                screenContext: screenContext,
                                blastData: blastData,
                                selectedItems: [],
                                isSearchMode: false,
                                searchText: '',
                                searchTop: 0,
                                drillingIn: 'still',
                                activeGoals: [],
                                activeContests: []
                            }, () => {

                                self.updateActiveGoals();
                                self.updateActiveContests();

                                if (!self.props.isPhone) {
                                    self.loadPeekData();
                                }

                                self.forceUpdate();
                                self.isScreenChanging = false;

                                if (newScreen == "emps") {
                                    this.props.blastService.track(this.state.blastFilter.companyId, this.state.blastFilter.storeId, this.state.screenContext.groupKey, 'changeMode', "PEEPS");
                                }
                                else if (newScreen == "emp") {
                                    this.props.blastService.track(this.state.blastFilter.companyId, this.state.blastFilter.storeId, this.state.screenContext.groupKey, 'changeMode', "PEEP");
                                }
                                else if (newScreen == "allemps") {
                                    this.props.blastService.track(this.state.blastFilter.companyId, this.state.blastFilter.storeId, this.state.screenContext.groupKey, 'changeMode', "ALLPEEPS");
                                }
                                else if (newScreen == "allemp") {
                                    this.props.blastService.track(this.state.blastFilter.companyId, this.state.blastFilter.storeId, this.state.screenContext.groupKey, 'changeMode', "ALLPEEP");
                                }
                                else if (newScreen == "loc") {
                                    this.props.blastService.track(this.state.blastFilter.companyId, this.state.blastFilter.storeId, this.state.screenContext.groupKey, 'changeMode', "STORE");
                                }
                                else {
                                    this.props.blastService.track(this.state.blastFilter.companyId, this.state.blastFilter.storeId, this.state.screenContext.groupKey, 'changeMode', "STORES");
                                }
                            });
                        }, transTime);

                    }, (err) => {
                        self.isScreenChanging = false;
                        self.setState({ drillingIn: 'still' });
                    });
                }, (err) => {
                    self.isScreenChanging = false;
                    self.setState({ drillingIn: 'still' });
                });
            }, (err) => {
                self.isScreenChanging = false;
                self.setState({ drillingIn: 'still' });
            });
        });
    }

    handleChangeScreenForce(screen) {
        if (!this.isScreenChanging) {
            this.isScreenChanging = true;
            this.backStack.push({ screen: this.state.screenContext.screen, groupKey: this.state.screenContext.groupKey, storeId: this.state.blastFilter.storeId });
            this.doChangeScreen(screen, undefined);
        }
    }

    handleChangeScreenLong(name, storeId) {
        if (this.state.screenContext.screen === 'locs' && !this.isScreenChanging) {
            this.isScreenChanging = true;
            this.backStack.push({ screen: this.state.screenContext.screen, groupKey: this.state.screenContext.groupKey, storeId: this.state.blastFilter.storeId });
            this.doChangeScreen("emps", name, storeId);
        }
    }

    handleChangeScreen(name) {
        let updateState = true;
        let newScreen;
        switch (this.state.screenContext.screen) {
            case 'locs':
                newScreen = "loc";
                break;
            case 'loc':
                newScreen = "emps";
                break;
            case 'emps':
                newScreen = "emp";
                break;
            case 'emp':
                updateState = false;
                break;
            case 'allemps':
                newScreen = "allemp";
                break;
            case 'allemp':
                updateState = false;
                break;
            case 'dists':
                newScreen = 'dist';
                break;
            case 'dist':
                newScreen = 'distLocs';
                break;
            case 'distLocs':
                newScreen = 'distLoc';
                break;
            case 'distLoc':
                newScreen = 'emps';
                break;
        }

        if (updateState && !this.isScreenChanging) {
            this.isScreenChanging = true;
            this.backStack.push({ screen: this.state.screenContext.screen, groupKey: this.state.screenContext.groupKey, storeId: this.state.blastFilter.storeId, districtId: this.state.blastFilter.districtId });
            this.doChangeScreen(newScreen, name);
        }
    }

    handleChangeScreenPrevious() {

        if (this.backStack.length > 0 && !this.isScreenChanging) {
            this.isScreenChanging = true;
            let backObj = this.backStack.pop();
            this.doChangeScreen(backObj.screen, backObj.groupKey, backObj.storeId, true, backObj.districtId);
        }
    }

    changeScreenLocked(locName) {

        if (locName === 'All') {
            if (!this.isScreenChanging && this.state.screenContext.screen != 'allemp') {
                this.isScreenChanging = true;
                this.doChangeScreen('allemp', this.meKey);
            }
        } else {

            let locations = this.userInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations;

            let selectedLocation = undefined;
            for (var i = 0; i < locations.length; i++) {
                if (locations[i].name === locName) {
                    selectedLocation = locations[i];
                    break;
                }
            }

            let filter = this.state.blastFilter;
            filter.storeId = selectedLocation.clusterID;

            this.blastDataManager.getEmployeeData(filter, (data) => {

                let selectedKey = null;
                let tempKeys = Object.keys(data);
                for (var i = 0; i < tempKeys.length; i++) {
                    if (tempKeys[i] != 'totals' && data[tempKeys[i]].length > 0 && data[tempKeys[i]][0].userId === this.userInfo.userId) {
                        selectedKey = tempKeys[i];
                        break;
                    }
                }

                if (selectedKey != null) {
                    this.doChangeScreen('emp', selectedKey, selectedLocation.clusterID);
                } else {
                    alert("You are not registered for the selected location");
                }
            });
        }
    }

    goToMe() {

        if (!this.isScreenChanging && this.state.screenContext.screen != 'allemp') {
            this.isScreenChanging = true;
            this.backStack.push({ screen: this.state.screenContext.screen, groupKey: this.state.screenContext.groupKey, storeId: this.state.blastFilter.storeId });
            this.doChangeScreen('allemp', this.meKey);
        }
    }

    toggleGroupsMode() {
        let self = this;

        let isGroupsMode = !self.state.isGroupsMode;
        window.localStorage.setItem('isGroupsMode', isGroupsMode);

        self.props.loadingOn(() => {
            let self = this;
            if (isGroupsMode) {
                self.dbm.saveSetting("compareMode", "lastYear");
            }
            self.setState({ isGroupsMode: isGroupsMode });
        });
    }

    onSwipeStart(event) {

    }

    onSwipeMove(position, event) {

        this.swipeX = position.x;
        this.swipeY = position.y;
    }

    onSwipeEnd(event) {

        let x = this.swipeX;
        let y = this.swipeY;
        this.swipeX = 0;
        this.swipeY = 0;

        if (this.swipeMode === 0) {

            if (Math.abs(x) >= Math.abs(y) * 3 && Math.abs(x) > 100 && Math.abs(y) < 100) {
                if (x < 0) {
                    this.onSwipeLeft();
                } else {
                    this.onSwipeRight();
                }
            }
        }
    }

    onSwipeLeft(event) {

        if ((this.state.screenContext.screen === 'emp' || this.state.screenContext.screen === 'allemp') &&
            this.isLocked()) {
            return;
        }

        let index = null;
        let prevIndex = null;

        for (var i = 0; i < this[this.state.screenContext.activeList].length; i++) {
            if (this[this.state.screenContext.activeList][i] === this.state.screenContext.groupKey) {
                prevIndex = i;
                index = i;
            }
        }

        if (index === null || this[this.state.screenContext.activeList].length <= 1) {
            // Don't swipe
            return;
        } else if (index === this[this.state.screenContext.activeList].length - 1) {
            index = 0;
        } else {
            index++;
        }

        this.animateSwipe(prevIndex, index, -1);
    }

    onSwipeRight(event) {

        if ((this.state.screenContext.screen === 'emp' || this.state.screenContext.screen === 'allemp') &&
            this.isLocked()) {
            return;
        }

        let index = null;
        let prevIndex = null;
        for (var i = 0; i < this[this.state.screenContext.activeList].length; i++) {
            if (this[this.state.screenContext.activeList][i] === this.state.screenContext.groupKey) {
                prevIndex = i;
                index = i;
            }
        }

        if (index === null || this[this.state.screenContext.activeList].length <= 1) {
            // Don't swipe
            return;
        } else if (index === 0) {
            index = this[this.state.screenContext.activeList].length - 1;
        } else {
            index--;
        }

        this.animateSwipe(prevIndex, index, 1);
    }

    animateSwipe(prevIndex, index, dir) {
        var self = this;

        let screenContext = this.state.screenContext;
        screenContext.groupKey = this[this.state.screenContext.activeList][index];

        let tmpSelectedItems = [];
        for (var i = 0; i < this.state.selectedItems.length; i++) {
            let cData = this.state.blastData[screenContext.groupKey];
            for (var j = 0; j < cData.length; j++) {
                if (cData[j].name === this.state.selectedItems[i].name) {
                    tmpSelectedItems.push(cData[j]);
                }
            }
        }

        this.swipeMode = dir;
        this.setState({
            screenContext: screenContext,
            //selectedItems: [],
            selectedItems: tmpSelectedItems,
            activeGoals: self.getActiveGoals(),
            activeContests: self.getActiveContests()
        }, () => {

            if (!this.props.isPhone) {
                this.loadPeekData();
            }

            self.curView.viewOuter.classList.remove('metrics-central-swiping-animation1');
            self.curView.viewOuter.classList.remove('metrics-central-swiping-animation-1');
            void self.curView.viewOuter.offsetWidth;
            self.curView.viewOuter.classList.add('metrics-central-swiping-animation' + dir);
            self.swipeMode = 0;
        });
    }

    searchBlastData() {

        if (this.state.blastData === undefined)
            return {};

        let top = 0;
        let resetTotals = false;
        let key = this.state.screenContext.groupKey;
        let blastData = Object.assign({}, this.state.blastData);

        if (this.state.searchTop != undefined && this.state.searchTop > 0) {
            top = this.state.searchTop;
            resetTotals = true;
        }

        if (this.state.searchText.trim().length > 0) {
            blastData[key] = _.filter(blastData[key], (obj) => {
                if (this.state.screenContext.isMetric) {
                    // return obj.kPIName.toLowerCase().startsWith(this.state.searchText.toLowerCase());
                    return obj.kPIName.toLowerCase().includes(this.state.searchText.toLowerCase());
                }
                else {
                    return obj.name.toLowerCase().includes(this.state.searchText.toLowerCase());
                }
            });
            resetTotals = true;
        }

        blastData[key] = this.blastDataManager.sortBlastData(this.state.blastFilter, blastData[key], this.state.screenContext.isMetric);

        if (top > 0) {
            blastData[key] = blastData[key].slice(0, top);
        }

        if (resetTotals) {
            if (blastData[key].length > 0 && blastData[key][0].type === 'PCT') {
                blastData.totals[key] = this.blastDataManager.calculateBlastAverages(blastData[key]);
            } else {
                blastData.totals[key] = this.blastDataManager.calculateBlastTotals(blastData[key]);
            }
        }

        return blastData;
    }

    textPeople() {

        if (this.state.blastData[this.state.screenContext.groupKey] === undefined || this.state.blastData[this.state.screenContext.groupKey] === null ||
            this.state.blastData[this.state.screenContext.groupKey].length === undefined || this.state.blastData[this.state.screenContext.groupKey].length === 0) {
            return;
        }

        let numbers = [];

        switch (this.state.screenContext.screen) {
            case 'locs':
                for (var i = 0; i < this.employeePhoneList.length; i++) {
                    if (this.employeePhoneList[i].stores.includes(this.state.selectedItems[0].storeId) &&
                        this.employeePhoneList[i].phone != undefined && this.employeePhoneList[i].phone != null && this.employeePhoneList[i].phone != '') {
                        numbers.push(this.employeePhoneList[i].phone.replace(/-/g, ''));
                    }
                }
                break;
            case 'loc':
                if (this.state.selectedItems.length === 0) {
                    for (var i = 0; i < this.employeePhoneList.length; i++) {
                        if (this.employeePhoneList[i].stores.includes(this.state.blastData[this.state.screenContext.groupKey][0].storeId) &&
                            this.employeePhoneList[i].phone != undefined && this.employeePhoneList[i].phone != null && this.employeePhoneList[i].phone != '') {
                            numbers.push(this.employeePhoneList[i].phone.replace(/-/g, ''));
                        }
                    }
                } else {
                    for (var i = 0; i < this.employeePhoneList.length; i++) {
                        for (var j = 0; j < this.state.selectedItems.length; j++) {
                            if (this.employeePhoneList[i].stores.includes(this.state.selectedItems[j].storeId) &&
                                this.employeePhoneList[i].phone != undefined && this.employeePhoneList[i].phone != null && this.employeePhoneList[i].phone != '') {
                                numbers.push(this.employeePhoneList[i].phone.replace(/-/g, ''));
                            }
                        }
                    }
                }
                break;
            case 'emps':
                if (this.state.selectedItems.length === 0) {
                    for (var i = 0; i < this.employeePhoneList.length; i++) {
                        if (this.employeePhoneList[i].stores.includes(this.state.blastData[this.state.screenContext.groupKey][0].storeId) &&
                            this.employeePhoneList[i].phone != undefined && this.employeePhoneList[i].phone != null && this.employeePhoneList[i].phone != '') {
                            numbers.push(this.employeePhoneList[i].phone.replace(/-/g, ''));
                        }
                    }
                } else {
                    for (var i = 0; i < this.employeePhoneList.length; i++) {
                        for (var j = 0; j < this.state.selectedItems.length; j++) {
                            if (this.employeePhoneList[i].name === this.state.selectedItems[j].name &&
                                this.employeePhoneList[i].phone != undefined && this.employeePhoneList[i].phone != null && this.employeePhoneList[i].phone != '') {
                                numbers.push(this.employeePhoneList[i].phone.replace(/-/g, ''));
                            }
                        }
                    }
                }
                break;
            case 'emp':
                for (var i = 0; i < this.employeePhoneList.length; i++) {
                    if (this.employeePhoneList[i].name === this.state.screenContext.groupKey &&
                        this.employeePhoneList[i].phone != undefined && this.employeePhoneList[i].phone != null && this.employeePhoneList[i].phone != '') {
                        numbers.push(this.employeePhoneList[i].phone.replace(/-/g, ''));
                    }
                }
                break;
            case 'allemps':
                for (var i = 0; i < this.employeePhoneList.length; i++) {
                    for (var j = 0; j < this.state.selectedItems.length; j++) {
                        if (this.employeePhoneList[i].name === this.state.selectedItems[j].name &&
                            this.employeePhoneList[i].phone != undefined && this.employeePhoneList[i].phone != null && this.employeePhoneList[i].phone != '') {
                            numbers.push(this.employeePhoneList[i].phone.replace(/-/g, ''));
                        }
                    }
                }
                break;
            case 'allemp':
                for (var i = 0; i < this.employeePhoneList.length; i++) {
                    if (this.employeePhoneList[i].name === this.state.screenContext.groupKey &&
                        this.employeePhoneList[i].phone != undefined && this.employeePhoneList[i].phone != null && this.employeePhoneList[i].phone != '') {
                        numbers.push(this.employeePhoneList[i].phone.replace(/-/g, ''));
                    }
                }
                break;
        }

        if (numbers.length > 0) {
            let numberString = numbers.join(',');
            let link = document.getElementById('dummy-link');
            if (usingiOS) {
                if (window.hasOwnProperty('cordova')) {
                link.href = 'sms://open?addresses=' + numberString;
                cordova.InAppBrowser.open(link.href, '_system'); 
                 }
                 else {
                // link.href = 'sms://open?addresses=6788953817,7069692932'
                link.href = 'sms://open?addresses=' + numberString;
                link.click();
                 }
            } else {
                // link.href = 'sms://6788953817,7069692932';
                link.href = 'sms://' + numberString;
                link.click();
            }
        } else if (this.state.selectedItems.length > 0) {
            alert("The selected people have no phone numbers associated with their account")
        } else {
            alert("No phone number available");
        }
    }

    callPeople() {

        if (this.state.blastData[this.state.screenContext.groupKey] === undefined || this.state.blastData[this.state.screenContext.groupKey] === null ||
            this.state.blastData[this.state.screenContext.groupKey].length === undefined || this.state.blastData[this.state.screenContext.groupKey].length === 0) {
            return;
        }

        let number = '';

        switch (this.state.screenContext.screen) {
            case 'locs':
                if (this.state.selectedItems.length > 0) {
                    number = this.state.selectedItems[0].phone.replace(/-/g, '');
                }
                break;
            case 'loc':
                number = this.state.blastData[this.state.screenContext.groupKey][0].phone.replace(/-/g, '');
                break;
            case 'emps':
                if (this.state.selectedItems.length > 0) {
                    number = this.state.selectedItems[0].phone.replace(/-/g, '');
                }
                break;
            case 'emp':
                number = this.state.blastData[this.state.screenContext.groupKey][0].phone.replace(/-/g, '');
                break;
            case 'allemps':
                if (this.state.selectedItems.length > 0) {
                    number = this.state.selectedItems[0].phone.replace(/-/g, '');
                }
                break;
            case 'allemp':
                number = this.state.blastData[this.state.screenContext.groupKey][0].phone.replace(/-/g, '');
                break;
        }

        if (number === undefined || number === null || number === '') {
            alert("This person does not have a phone number associated with their account")
        } else {

            let link = document.getElementById('dummy-link');
            if (usingiOS) {
                if (window.hasOwnProperty('cordova')) {
                    cordova.InAppBrowser.open('tel:' + number, '_system'); 
                 }
                 else {
                link.href = 'tel:' + number;
                link.click();
                 }
            } else {
                link.href = 'tel:' + number;
                link.click();
            }
            
        }
    }

    canSelectPeriod(range, screen) {

        if (screen === undefined || screen === null) {
            screen = this.state.screenContext.screen;
        }

        let screenContext = this.state.screenContext;
        let accountInfo = this.state.accountInfo;
        if (screenContext != undefined && screenContext != null &&
            accountInfo != undefined && accountInfo != null) {

            let pCheckList = screen === 'emps' || screen === 'emp' ||
                screen === 'allemps' || screen === 'allemp' ? accountInfo.mobileEmployeePeriods : accountInfo.mobileLocationPeriods;

            let checkRange = range === 'CUR' ? 'NOW' : range;

            for (var i = 0; i < pCheckList.length; i++) {
                if (checkRange === pCheckList[i]) {
                    return true;
                }
            }
            return false;

        } else {
            return false;
        }
    }

    setRightOption(option) {
        let rightOptions = this.state.rightOptions;
        if (rightOptions[option]) {

            if (option != 'peek') {
                rightOptions.chart.hold = false;
                rightOptions.goals.hold = false;
                rightOptions.contests.hold = false;
                rightOptions.clipBoard.hold = false;

                rightOptions.peek.active = false;
            }
            rightOptions.peek.hold = false;

            let wasSolo = rightOptions[option].solo;

            rightOptions.chart.solo = false;
            rightOptions.goals.solo = false;
            rightOptions.contests.solo = false;
            rightOptions.clipBoard.solo = false;
            rightOptions.peek.solo = false;

            if (!wasSolo) {
                rightOptions[option].active = !rightOptions[option].active;
                if (option === 'peek') {
                    if (rightOptions.peek.active) {
                        rightOptions.chart.hold = true;
                        rightOptions.goals.hold = true;
                        rightOptions.contests.hold = true;
                        rightOptions.clipBoard.hold = true;
                    } else {
                        rightOptions.chart.hold = false;
                        rightOptions.goals.hold = false;
                        rightOptions.contests.hold = false;
                        rightOptions.clipBoard.hold = false;
                    }
                }
            }

            this.setState({ rightOptions: rightOptions });
        }
    }

    setRightOptionSolo(option) {
        let rightOptions = this.state.rightOptions;
        if (rightOptions[option]) {

            rightOptions[option].solo = true;
            rightOptions[option].active = true;
            rightOptions[option].hold = false;

            if (option != 'peek') {
                rightOptions.peek.active = false;
            }

            let keys = Object.keys(rightOptions);
            for (var i = 0; i < keys.length; i++) {
                if (keys[i] != option) {
                    rightOptions[keys[i]].hold = true;
                    rightOptions[keys[i]].solo = false;
                }
            }

            this.setState({ rightOptions: rightOptions })
        }
    }

    async loadPeekData() {
        let self = this;

        let peekScreen = null;
        switch (this.state.screenContext.screen) {
            case 'locs':
                peekScreen = "loc";
                break;
            case 'loc':
                peekScreen = "emps";
                break;
            case 'emps':
                peekScreen = "emp";
                break;
            case 'emp':
                peekScreen = null;
                break;
            case 'allemps':
                peekScreen = "allemp";
                break;
            case 'allemp':
                peekScreen = null;
                break;
            case 'dists':
                peekScreen = 'dist';
                break;
            case 'dist':
                peekScreen = 'distLocs';
                break;
            case 'distLocs':
                peekScreen = 'distLoc';
                break;
            case 'distLoc':
                peekScreen = 'emps';
                break;
        }

        let blastFilter = Object.assign({}, this.state.blastFilter);
        if (peekScreen === "emps" || peekScreen === "emp") {
            blastFilter.storeId = this.state.blastData[this.state.screenContext.groupKey][0].storeId;
        }
        if (peekScreen === 'distLocs' || peekScreen === 'distLoc') {
            blastFilter.districtId = this.state.blastData[this.state.screenContext.groupKey][0].districtId;
        }

        if (peekScreen != null) {
            this.loadBlastData(blastFilter, peekScreen, (data) => {

                let peekScreenContext = this.state.peekScreenContext != null && this.state.peekScreenContext.screen === peekScreen ?
                    this.state.peekScreenContext : self.setScreenContext(peekScreen, this.state.blastFilter);

                self.setState({ peekBlastData: data, peekScreenContext: peekScreenContext });
            });
        } else {
            self.setState({ peekBlastData: null });
        }
    }

    canPeek() {
        let screen = this.state.screenContext.screen;
        return (
            this.state.peekBlastData != undefined && this.state.peekBlastData != null &&
            (((screen === 'dists' || screen === 'distLocs' || screen === 'locs' || screen === 'emps' || screen === 'allemps') &&
                this.state.selectedItems.length === 1 && this.state.peekBlastData[this.state.selectedItems[0].name] != undefined) ||
                ((screen === 'dist' || screen === 'distLoc' || screen === 'loc' || screen === 'emp' || screen === 'allemp') &&
                    this.state.peekBlastData[this.state.peekScreenContext.groupKey] != undefined))
        )
    }

    render() {

        let searchedBlastData = this.searchBlastData()
        let unsearchedBlastData = null;
        let canPeek = false;
        let peekData = null;
        let peekListContent = [];
        let peekSelectorActive = false;
        if (!this.props.isPhone) {
            unsearchedBlastData = Object.assign({}, this.state.blastData);
            unsearchedBlastData[this.state.screenContext.groupKey] = this.blastDataManager.sortBlastData(this.state.blastFilter, unsearchedBlastData[this.state.screenContext.groupKey], this.state.screenContext.isMetric);

            canPeek = this.canPeek();
            if (canPeek) {
                let screen = this.state.screenContext.screen;
                if (screen === 'dists' || screen === 'distLocs' || screen === 'locs' || screen === 'emps' || screen === 'allemps') {
                    peekData = this.state.peekBlastData[this.state.selectedItems[0].name];
                } else {
                    peekData = this.state.peekBlastData[this.state.peekScreenContext.groupKey];
                    peekSelectorActive = true;
                }

                peekListContent = this[this.state.peekScreenContext.activeList];
            }
        }

        return (
            <div id="page-outer" className="metrics-page-outer">
                <MetricsTopBar
                    canCreateMetricGroups={this.state.canCreateMetricGroups}
                    isGroupsMode={this.state.isGroupsMode}
                    isPhone={this.props.isPhone}
                    userType={this.state.userType}
                    accountInfo={this.state.accountInfo}
                    meKey={this.meKey}
                    hasDistricts={this.hasDistricts || this.state.isGroupsMode}
                    primaryLocation={this.primaryLocation}
                    employeeLocked={this.isLocked()}
                    locationList={this.locationList}
                    isSearchMode={this.state.isSearchMode}
                    searchText={this.state.searchText}
                    handleSearch={this.handleSearch}
                    handleSearchTop={this.handleSearchTop}
                    searchTop={this.state.searchTop}
                    selectedItems={this.state.selectedItems}
                    isScrollTop={this.state.isScrollTop}
                    scrollToTop={this.scrollToTop}
                    toggleNav={this.props.toggleNav}
                    toggleSearch={this.toggleSearch}
                    activeListContent={this[this.state.screenContext.activeList]}
                    blastData={this.state.blastData}
                    blastFilter={this.state.blastFilter}
                    clearSelectedItems={this.clearSelectedItems}
                    selectAllItems={this.selectAllItems}
                    screenContext={this.state.screenContext}
                    back={this.handleChangeScreenPrevious}
                    goToMe={this.goToMe}
                    toggleGroupsMode={this.toggleGroupsMode}
                    changeScreen={this.handleChangeScreenForce}
                    changeTopSelector={this.handleChangeTopSelector}
                    changePeekTopSelector={this.handleChangePeekTopSelector}
                    forceBlast={this.handleForceBlast}
                    textPeople={this.textPeople}
                    callPeople={this.callPeople}
                    isScrollDirectionDown={this.state.isScrollDirectionDown}
                    rightOptions={this.state.rightOptions}
                    canPeek={canPeek}
                    peekData={peekData}
                    peekListContent={peekListContent}
                    peekScreenContext={this.state.peekScreenContext}
                    peekSelectorActive={peekSelectorActive}
                    promptForLongData={this.promptForLongData}
                />
                <Swipe
                    style={{ width: '100%', height: '100%' }}
                    onSwipeStart={this.onSwipeStart}
                    onSwipeMove={this.onSwipeMove}
                    onSwipeEnd={this.onSwipeEnd}
                >
                    <MetricsViewCentral
                        isPhone={this.props.isPhone}
                        ref={(curView) => { this.curView = curView }}
                        isGroupsMode={this.state.isGroupsMode}
                        hasDistricts={this.hasDistricts || this.state.isGroupsMode}
                        selectedItems={this.state.selectedItems}
                        toggleSelectedItem={this.toggleSelectedItem}
                        changeSort={this.changeSort}
                        changeScreen={this.handleChangeScreen}
                        changeScreenLong={this.handleChangeScreenLong}
                        promptForLongData={this.promptForLongData}
                        isScrollTop={this.state.isScrollTop}
                        handleScrollTop={this.handleScrollTop}
                        scrollToTop={this.scrollToTop}
                        handleScrollDirection={this.handleScrollDirection}
                        blastData={searchedBlastData}
                        blastFilter={this.state.blastFilter}
                        rotateDataMode={this.rotateDataMode}
                        screenContext={this.state.screenContext}
                        accountInfo={this.state.accountInfo}
                        userId={this.state.userId}
                        dbm={this.dbm}
                        activeGoals={this.state.isGroupsMode ? [] : this.state.activeGoals}
                        activeContests={this.state.isGroupsMode ? this.state.activeContests : this.state.activeContests}
                        textPeople={this.textPeople}
                        callPeople={this.callPeople}
                        lastBlastReload={this.state.lastBlastReload}
                        storeMap={this.storeMap}
                        locationMap={this.locationMap}
                        handleSearchTop={this.handleSearchTop}
                        searchTop={this.state.searchTop}
                        rotateSort={this.rotateSort}
                        rotateSortDir={this.rotateSortDir}
                        rotateFilter={this.rotateFilter}
                        isScrollDirectionDown={this.state.isScrollDirectionDown}
                        drillingIn={this.state.drillingIn}
                        userType={this.state.userType}
                        meKey={this.meKey}
                        primaryLocation={this.primaryLocation}
                        employeePhoneList={this.employeePhoneList}
                        swipeMode={this.swipeMode}
                        setCompareMode={this.setCompareMode}
                    />
                    {
                        this.props.isPhone ? null :
                            <MetricsViewRight
                                isPhone={this.props.isPhone}
                                hasDistricts={this.hasDistricts || this.state.isGroupsMode}
                                selectedItems={this.state.selectedItems}
                                toggleSelectedItem={this.toggleSelectedItem}
                                changeSort={this.changeSort}
                                changeScreen={this.handleChangeScreen}
                                changeScreenLong={this.handleChangeScreenLong}
                                promptForLongData={this.promptForLongData}
                                isScrollTop={this.state.isScrollTop}
                                handleScrollTop={this.handleScrollTop}
                                scrollToTop={this.scrollToTop}
                                handleScrollDirection={this.handleScrollDirection}
                                blastData={searchedBlastData}
                                unsearchedBlastData={unsearchedBlastData}
                                blastFilter={this.state.blastFilter}
                                rotateDataMode={this.rotateDataMode}
                                screenContext={this.state.screenContext}
                                accountInfo={this.state.accountInfo}
                                userId={this.state.userId}
                                dbm={this.dbm}
                                activeGoals={this.state.isGroupsMode ? [] : this.state.activeGoals}
                                activeContests={this.state.isGroupsMode ? this.state.activeContests : this.state.activeContests}
                                textPeople={this.textPeople}
                                callPeople={this.callPeople}
                                lastBlastReload={this.state.lastBlastReload}
                                storeMap={this.storeMap}
                                locationMap={this.locationMap}
                                handleSearchTop={this.handleSearchTop}
                                searchTop={this.state.searchTop}
                                rotateSort={this.rotateSort}
                                rotateSortDir={this.rotateSortDir}
                                rotateFilter={this.rotateFilter}
                                isScrollDirectionDown={this.state.isScrollDirectionDown}
                                drillingIn={this.state.drillingIn}
                                userType={this.state.userType}
                                meKey={this.meKey}
                                primaryLocation={this.primaryLocation}
                                employeePhoneList={this.employeePhoneList}
                                swipeMode={this.swipeMode}
                                rightOptions={this.state.rightOptions}
                                canPeek={canPeek}
                                peekData={peekData}
                                peekScreenContext={this.state.peekScreenContext}
                            />
                    }
                </Swipe>
                <MetricsBottomBar
                    isGroupsMode={this.state.isGroupsMode}
                    isPhone={this.props.isPhone}
                    changeDate={this.changeDate}
                    selectedItems={this.state.selectedItems}
                    blastData={searchedBlastData}
                    blastFilter={this.state.blastFilter}
                    updateBlastFilter={this.updateBlastFilter}
                    screenContext={this.state.screenContext}
                    accountInfo={this.state.accountInfo}
                    rotateDataMode={this.rotateDataMode}
                    canSelectPeriod={this.canSelectPeriod}
                    rightOptions={this.state.rightOptions}
                    setRightOption={this.setRightOption}
                    setRightOptionSolo={this.setRightOptionSolo}
                />
            </div>
        );
    }
}
